import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useTournament } from 'context/TournamentContext';

import EndPage from 'components/End/EndPage';
import ModalFull from 'components/ui/ModalFull';

import {
  LineText
} from './styled';

type TournamentCountdownProps = {
    date?: string;
};

export const TournamentCountdown = ({ date }: TournamentCountdownProps) => {
  const [timeLeft, setTimeLeft] = useState('');
  const { tournamentDetails, tournamentStatus } = useTournament();

  const calculateTimeLeft = () => {
    const rawData: any = tournamentDetails?.data;
    const attributes = rawData?.attributes ?? rawData?.data ?? rawData;
    const effectiveDate = date ?? attributes?.end_at;

    if (!effectiveDate) {
      setTimeLeft('');
      return;
    }

    const now = moment().utc();
    const end = moment.utc(effectiveDate);
    const diffMs = end.diff(now);

    // TEAM_004: Clamp countdown at zero so it never shows negative values
    if (diffMs <= 0) {
      setTimeLeft('0d 0h 0m 0s');
      return;
    }

    const duration = moment.duration(diffMs);
    const totalDays = Math.floor(duration.asDays());
    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();

    setTimeLeft(`${totalDays}d ${hours}h ${minutes}m ${seconds}s`);
  };

  useEffect(() => {
    calculateTimeLeft();
    const intervalId = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(intervalId);
  }, [date, tournamentDetails]);

  // When countdown reaches or passes zero, show the end modal
  // instead of forcing a full page reload (which caused infinite loops).
  if (tournamentStatus === 'FINISHED' && '0d 0h 0m 0s' >= timeLeft && timeLeft !== '') {
    return <ModalFull><EndPage tournamentDetails={tournamentDetails} /></ModalFull>;
  }

  return <LineText className="timeText">{timeLeft}</LineText>;
};

export default TournamentCountdown;
